'use client';

import { ReactNode } from 'react';

import Image from 'next/image';

import leftArrowIcon from '@/assets/icons/home-page-slider-chevron-right.svg';

interface BannerCarouselDotsProps {
  dots: ReactNode;
  goNext: () => void;
  goBack: () => void;
}

const BannerCarouselDots = ({ dots, goBack, goNext }: BannerCarouselDotsProps) => {
  return (
    <div className="v2-absolute v2-left-0 -v2-bottom-[45px] v2-z-[1] v2-flex v2-h-[52px] v2-w-full v2-items-center v2-justify-center v2-gap-3">
      <button
        className="v2-flex v2-h-9 v2-w-9 v2-items-center v2-justify-center v2-border-0 v2-bg-transparent"
        onClick={goNext}
      >
        <Image className="!rotate-180" src={leftArrowIcon} alt="" />
      </button>
      <ul className="v2-mt-1 v2-flex v2-h-9 v2-items-center v2-justify-center v2-gap-3">{dots}</ul>
      <button
        className="v2-flex v2-h-9 v2-w-9 v2-items-center v2-justify-center v2-border-0 v2-bg-transparent"
        onClick={goBack}
      >
        <Image src={leftArrowIcon} alt="" />
      </button>
    </div>
  );
};

export default BannerCarouselDots;
